
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { useToast } from '@/hooks/use-toast';

export interface UseSignOutReturn {
  signOut: () => Promise<void>;
  isLoading: boolean;
}

export const useSignOut = (): UseSignOutReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  const signOut = async () => {
    try {
      console.log("Signing out user");
      setIsLoading(true);
      const { error } = await supabase.auth.signOut();

      if (error) {
        console.error('Error signing out:', error);
        toast({
          title: 'Error signing out',
          description: error.message,
          variant: 'destructive',
        });
      } else {
        toast({
          title: 'Successfully signed out',
          description: 'You have been signed out of your account',
        });
        navigate('/');
      }
    } catch (error) {
      console.error('Unexpected error during sign out:', error);
      toast({
        title: 'Error signing out',
        description: 'An unexpected error occurred',
        variant: 'destructive',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    signOut,
    isLoading
  };
};
